import Configurator from '../../../../../configurator'
import { wrapperClickOutside } from '../../../filters/helper'
import Button from '../../../shared/sn-button'
import i18n from '../../../../../locales/i18n'
import SnIcon from '../../../shared/sn-icon'
import React from 'react'
import { setFriendshipStatus } from './renderFriendshipButtons'
import { callSetFriendshipStatus } from '../../../sportnections/helpers'

class FriendshipButton extends Configurator {
    state = {
        showDropdown: false,
    }

    /**
     * Set status between sportnections
     *
     * @param {Object} _that
     * @param {number} newStatus
     * @param {string} confirmMessage
     * @returns {null|Promise<T>}
     */
    setFriendshipStatus = (_that, newStatus, confirmMessage = null) => {
        _that.setFriendshipLoader(null, true)

        const caller = callSetFriendshipStatus(_that.state.user, newStatus, confirmMessage)

        if (!caller) {
            return null
        }

        return caller.then(() => {
            window.location.reload()
        })
    }

    /**
     * Show / hide dropdown submenu
     */
    toggleDropdown = () => {
        this.setState({ showDropdown: !this.state.showDropdown })
    }

    render() {
        const { showDropdown } = this.state

        const { upperState } = this.props

        return (
            <Button
                className="u-circle no-focus-outline"
                onClick={() => this.toggleDropdown(upperState)}
            >
                <div className="u-circle__icon">
                    <SnIcon
                        isHoverable={true}
                        className="sn-lg text-color-accent"
                        notHoverClassName="sn-invitation-circle-empty"
                        hoverClassName="sn-invitation-circle-fill"
                    />
                </div>
                {i18n.t('sportnectionRequestVerb')}
                {showDropdown &&
                    <div className="u-button__attend-menu">
                        <div
                            onClick={() => setFriendshipStatus(upperState, 2)}
                            className="u-button__attend-menu-item"
                        >
                            {i18n.t('accept')}
                        </div>
                        <div
                            onClick={() => setFriendshipStatus(upperState, 3, i18n.t('removeSportnectionRequestQuestion'))}
                            className="u-button__attend-menu-item"
                        >
                            {i18n.t('decline')}
                        </div>
                    </div>
                }
            </Button>
        )
    }
}
export default wrapperClickOutside(FriendshipButton, 'showDropdown', 'toggleDropdown')
